export default __webpack_public_path__ + "static/media/c005-whatsapp-02-en.b8520794.png";